import Vue from 'vue'
import Vuex from 'vuex'
import _forEach from 'lodash/forEach'
import { doors } from '../config/global.json'
import root from '../store/root'
import door from '../store/door'

require('es6-promise').polyfill()

Vue.use(Vuex)

const store = new Vuex.Store(root)
_forEach(doors, (key) => {
  store.registerModule(key, door)
})

export default store



// WEBPACK FOOTER //
// ./src/services/StoreService.js